<h1>Chat</h1>
<h2>{{ userName }}</h2>
<div class="chat-container">
  <div class="chat-sidebar">
    <h3>Chats</h3>
    <ul>
      <li *ngFor="let chatRoom of chatRooms"
          [class.selected]="chatRoom.id === selectedChatRoomId"
          (click)="selectChatRoom(chatRoom.id)">
        {{ chatRoom.recipients }}
      </li>
    </ul>
    <button (click)="openCreateChatRoomDialog()">New Message</button>
    
    <h3>Available Patients</h3>
    <ul>
      <li *ngFor="let user of availablePatientUsers">
        <input
          type="checkbox"
          [value]="user.id"
          [checked]="isRecipientSelected(user.id)"
          (change)="onRecipientChange($event)"
        />
        {{ user.name }}
      </li>
    </ul>

    <h3>Available Provider Users</h3>
    <ul>
      <li *ngFor="let user of availableProviderUsers">
        <input
          type="checkbox"
          [value]="user.id"
          [checked]="isRecipientSelected(user.id)"
          (change)="onRecipientChange($event)"
        />
        {{ user.name }}
      </li>
    </ul>

  </div>
  <div class="chat-window">
    <div class="message-display">
      <ul>
        <li *ngFor="let message of messages">
          <strong>{{ message.senderName }}: </strong>
          <span [innerHTML]="message.content"></span>
        </li>
      </ul>
    </div>
    <div class="message-input">
      <input [(ngModel)]="newMessage" placeholder="Type your message..." (keydown.enter)="sendMessage()">
      <button (click)="sendMessage()">Send Message</button>
      <button (click)="createZoomMeeting()">Create Zoom Meeting</button>
    </div>
  </div>
</div>
